import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks, Search} from '../../../partials'
import {useLayout} from '../../core'
//import Keycloak from 'keycloak-js';
import {  useLocation, useHistory } from "react-router-dom";

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'
/*
  const keycloak = new Keycloak({
    //url: "http://keycloak-dotstow-dev-alb-1135353619.us-east-2.elb.amazonaws.com/auth",
    url:process.env.React_App_KEYCLOAK_URL,
    
    realm: "SNV3",
    clientId: "snv3_ui"
  });
  */
 
  const handleLogout=()=>
  {
    //alert("test");
   // let history = useHistory();
   // history.push('/?action=logout');
   //keycloak.logout();
   window.location.href="/";

/*
   keycloak.logout().then((success:any) => {
    console.log("--> log: logout success ", success );
   // alert("test");
    keycloak.authenticated = false;
    window.location.replace("/dashboard");
}).catch((error:any) => {
    alert(error);
    console.log("--> log: logout error ", error );
});
*/


  // window.location.href="/?action=logout";
   // sessionStorage.clear();  

      //keycloak.logout();      
      //keycloak.authenticated = false;

     
     // window.location.replace("/Home");
      //window.location.replace("/Home?loginRedirect=1");
      //handleLogin();
      //window.location.replace("/");
      //setTimeout(function() {window.location.replace("/thankyou");}, 2000);
      //window.location.replace("/Home");
      //window.location.href = "/thankyou";
  }
  

const Topbar: FC = () => {
  const {config} = useLayout()

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* Search */}
      {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}


      <div>
       
       <a href="/logout" >Log Out</a> 
      </div>



    






    



    

     

     
     
     

    </div>
  )
}

export {Topbar}